export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/wu.5ddb0fd3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};